/// <reference path="irep.js"/>

IREP.TourToWin = (function () {
	var firsttime = true;
	var bW2s2 = true;
	var bW2s3 = true;
	var bW2s4 = true;
	var bW3s2 = true;
	var bW3s3 = true;
	var bW3s4 = true;
	var sr = true;
	var curWeek = 6;
	var curTourPage = 6;
	var curLearningPage = 6;

	var fillData = function (source, count) {
		var params = { PaxUID: IREP.options.user.currentUID, source: source, tokenCount:count };
		IREP.callApi("TourToWin/InsertToken", "GET", params).done(function (data) {
			ProcessTTWData(data)
		});
	};

	function ProcessTTWData(data) {
		var drawingEntries = 0;
		var availableTokens = 0;
		var purchased = 0;

		var info = data.ttwInfo;
		if (info != null) {
			availableTokens = info.availableTokens;
			drawingEntries = info.drawingEntries;
			purchased = info.purchased;

			if (firsttime) {
				$("#currentDrawingEntries").html(drawingEntries);
				firsttime = false;
			} else {
				var oldDE = $("#currentDrawingEntries").html();
				$("#currentDrawingEntries").html('+' + (drawingEntries - oldDE));
				setTimeout(function () { $("#currentDrawingEntries").html((drawingEntries)); }, 2000);
			}

			$("#currentAvailableTokens").html(availableTokens);

			if (availableTokens > 0) {
				$(".statusGray").addClass("statusBlue");
				$(".statusDarkGray").addClass("statusDarkBlue");
				$("#btnRedeemToken").fadeIn(500);
				$("#btnNoTokens").hide();
			} else {
				$("#btnNoTokens").fadeIn(500);
				$("#btnRedeemToken").hide();
				$(".statusGray").removeClass("statusBlue");
				$(".statusDarkGray").removeClass("statusDarkBlue");
			}

			$(".status").fadeIn(500);

			if (purchased < 16 && IREP.options.user.chipCount > 500) {
				$("#btnBuy1Token").show();
				$("#btnBuy5Tokens").show();
			} else if (purchased < 20 && IREP.options.user.chipCount > 250) {
				$("#btnBuy1Token").show();
				$("#btnBuy5Tokens").hide();
			} else {
				$("#btnBuy1Token").hide();
				$("#btnBuy5Tokens").hide();
				info.message = 3;
			}

			switch (info.message) {
				case 1:
					$("#TTWReturnMessage").html('<span style="color:#00adef">Congrats—you’ve just received 1 Tour Token. We’ve deducted the Credits from your account.</span>');
					break;
				case 2:
					$("#TTWReturnMessage").html('<span style="color:red">Sorry—you don’t have enough Credits to purchase that amount of Tour Tokens.</span>');
					break;
				case 3:
					$("#TTWReturnMessage").html('<span style="color:red">Sorry—you may only purchase up to 20 additional Tour Tokens per week.</span>');
					break;
				case 4:
					$("#TTWReturnMessage").html('<span style="color:#00adef">Congrats—you’ve just received 5 Tour Tokens. We’ve deducted the Credits from your account.</span>');
					break;
				default:
					break;
			}
		}
	}

	var redeemToken = function () {
		var params = { PaxUID: IREP.options.user.currentUID };
		IREP.callApi("TourToWin/RedeemToken", "GET", params).done(function (data) {
			ProcessTTWData(data);
		});
	};

	var init = function () {
		IREP.TourToWin.fillData('', 0);
		$("#btnBuy1Token").click(function () { IREP.TourToWin.fillData('purchased', 1); });
		$("#btnBuy5Tokens").click(function () { IREP.TourToWin.fillData('purchased', 5); });
		$("#btnRedeem1Token").click(function () { IREP.TourToWin.redeemToken(); });
		$("#prevLearning").on("click", function () { changePage("learning", -1); });
		$("#prevTour").on("click", function () { changePage("tour", -1); });
		$("#nextLearning").on("click", function () { changePage("learning", 1); });
		$("#nextTour").on("click", function () { changePage("tour", 1); });

		IREP.callApi("TourToWin/GetTourCompletions", "GET").done(function (data) {
			var tours = data.ttwTourCompletions;
			
			if (tours != null) {
				if (tours.week1) {
					$("#week1TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour1_completed.png");
				} else {
					$("#week1TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour1.png");
				}

				if (tours.week2) {
					$("#week2TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour2_completed.png");
				} else {
					$("#week2TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour2.png");
				}

				if (tours.week3) {
					$("#week3TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour3_completed.png");
				} else {
					$("#week3TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour3.png");
				}

				if (tours.week4) {
					$("#week4TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour4_completed.png");
				} else {
					$("#week4TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour4.png");
				}

				if (tours.week5) {
					$("#week5TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour5_completed.png");
				} else {
					$("#week5TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour5.png");
				}

				if (tours.week6) {
					$("#week6TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour6_completed.png");
				} else {
					$("#week6TourImage").attr("src", "../Content/images/Promotions/TourToWin/weeklyTour6.png");
				}
			}
		});
	};

	var finishTour = function (src) {
		IREP.TourToWin.fillData(src, 1);
	};

	var showRibbon = function () {
		if (sr) { 
			$("<div class='TTWTourRibbon'></div>").insertAfter("#primaryNavBar");
			$(".TTWTourRibbon").click(function () { $('#ttwBand').popup('show'); $(".TTWTourRibbon").remove(); });
			$(".TTWTourRibbon").animate({top:"0px"}, 500)
		}
	}

	var startWeek2 = function () {
		$(".tagApplyClear").click(function () { IREP.TourToWin.w2s2();});
	}

	var w2s2 = function () {
		if (bW2s2) {
			$("#week2step1").html("<div class='TTWBandHeader'>Great job. Now, let’s get some more details about a Learning activity. When you click a Learning activity’s thumbnail, you’ll find a short description and other information. Then, when you complete it, you can provide ratings and comments. </div><div class='TTWBandCopy'><span style='font-weight:bold'>Task:</span> <br />Reveal more details about a Learning activity.<br /><br /><span style='font-weight:bold'>How:</span> <br />Click a Learning activity’s thumbnail. </div>");
			$('#ttwBand').popup('show');
			//setTimeout("IREP.TourToWin.bindLearningClicks()", 1000);
			$("body").on("irep.drawer.open", ".activityDetailContainer", function () { IREP.TourToWin.w2s3(); });
			bW2s2 = false;
		}
	}

	var w2s3 = function () {
		if (bW2s3) {
			$("#week2step1").html("<div class='TTWBandHeader'>OK, one more stop to go! There’s a new way to find Learning activities. We’ve grouped several Learning activities into different themes on the Skills page. </div><div class='TTWBandCopy'><span style='font-weight:bold'>Task:</span> <br />Go to the Skills section.<br /><br /><span style='font-weight:bold'>How:</span> <br />Click Skills on the top right side of this page.</div>");
			$('#ttwBand').popup('show');
			$("#SkillsNav").click(function () { IREP.TourToWin.w2s4(); });
			bW2s3 = false;
		}
	}

	var w2s4 = function () {
		if (bW2s4) {
			$("#week2step1").html("<div class='TTWBandHeader'>Nice job! You completed this Tour and earned one Tour Token.  </div><div class='TTWBandCopy'>You can earn another Tour Token by completing this week’s featured Learning activities. <br /><br />Don’t forget to redeem your Tour Tokens—visit the <a href='tourtowindetails'>Tour to Win Details</a> page.</div>");
			$("#ttwBand > div").css("max-height", "230px");
			$('#ttwBand').popup('show');
			$(".ttwBandContinue").html("GO >");
			sr = false;
			bW2s4 = false;
			IREP.TourToWin.finishTour('week2');
			$(".TTWTourRibbon").remove();
		}
	}

	var w3s1 = function () {
		$("#referralBandShowMore").click(function () { IREP.TourToWin.w3s2(); });
	}

	var w3s2 = function () {
		if (bW3s2) {
			$("#week3step1").html("<div class='TTWBandHeader'>How easy was that? Now, let’s check out one of the coolest new features of the site—the Leaderboard, where you can find an interactive map, Badge information, and much more. Let’s go!</div><div class='TTWBandCopy'><span style='font-weight:bold'>Task:</span> <br />Go to the Leaderboard.<br /><br /><span style='font-weight:bold'>How:</span><ul><li>Use the top navigation—roll over or touch Community, and then select Leaderboard.<br/>OR</li><li>Find the Leaderboard band on this page and click <strong>Leaderboard.</strong></li></ul> </div>");
			$("#ttwBand > div").css("max-height", "350px");
			$('#ttwBand').delay(1000).popup('show');
			bW3s2 = false;
		}
	}

	var w3s3 = function () {
		$("#ddlCategory").change(function () {
			IREP.TourToWin.w3s4();
		});
	}

	var w3s4 = function () {
		if (bW3s4) {
			$("#week3step2").html("<div class='TTWBandHeader'>Nice job! You completed this Tour and earned one Tour Token.  </div><div class='TTWBandCopy'>You can earn another Tour Token by completing this week’s featured Learning activities. <br /><br />Don’t forget to redeem your Tour Tokens—visit the <a href='tourtowindetails'>Tour to Win Details</a> page.</div>");
			$("#ttwBand > div").css("max-height", "230px");
			$(".ttwBandContinue").html("GO >");
			$('#ttwBand').delay(1000).popup('show');
			sr = false;
			bW3s4 = false;
			IREP.TourToWin.finishTour('week3');
			$(".TTWTourRibbon").remove();
		}
	}

	var w4s2 = function () {
	    $("body").on("badge.drawer.open", ".badge", function () { setTimeout(function () { IREP.TourToWin.w4s3(); }, 2000); });
	}

	var w4s3 = function () {
	    if (bW3s3) {
	        $("#week4step2").html("<div class='TTWBandHeader'>That was almost too easy. Do you know that we’ve updated the requirements for each Status level? Review what you need to do to move on up!</div><div class='TTWBandCopy'><span style='font-weight:bold'>Task:</span> <br />Find the Status/Credits page.<br /><br /><span style='font-weight:bold'>How:</span><ul><li>Use the top navigation—roll over or touch Rewards, and then select Status/Credits.<br/>OR</li><li>Click <strong>Learn more about Credits</strong> in the top right corner of the Badge wall (right under your Credit count!).</li></ul> </div>");
	        $("#ttwBand > div").css("max-height", "350px");
	        $('#ttwBand').popup('show');
	        bW3s3 = false;
	    }
	}

	var w5s1 = function () {
		$("#btnChgViewAll").click(function () { IREP.TourToWin.w5s2(); });
		$("#divDashboardLink").children().attr("href", "/50/asmo/dashboard?launchTour=1");
	}

	var w5s2 = function () {
		if (bW3s2) {
			$("#week5step1").html("<div class='TTWBandHeader'>Excellent! Now, we’re going to change gears and visit the Dashboard where you can check your Status, edit your Profile, and more!</div><div class='TTWBandCopy'><span style='font-weight:bold'>Task:</span> <br />Go to your Dashboard.<br /><br /><span style='font-weight:bold'>How:</span><ol><li>Click the My Account icon at the top of the page.</li><li>Click <strong>My Dashboard.</strong></li></ol> </div>");
			$("#ttwBand > div").css("max-height", "350px");
			$('#ttwBand').popup('show');
			bW3s2 = false;
		}
	}

	var w5s3 = function () {
		$("#ChipMeterShowDetails").click(function () { IREP.TourToWin.w5s4(); });
	}

	var w5s4 = function () {
		if (bW3s4) {
			$("#week5step3").html("<div class='TTWBandHeader'>Nice job! You completed this Tour and earned one Tour Token.  </div><div class='TTWBandCopy'>You can earn another Tour Token by completing this week’s featured Learning activities. <br /><br />Don’t forget to redeem your Tour Tokens—visit the <a href='tourtowindetails'>Tour to Win Details</a> page.</div>");
			$("#ttwBand > div").css("max-height", "230px");
			$(".ttwBandContinue").html("GO >");
			$('#ttwBand').delay(1000).popup('show');
			sr = false;
			bW3s4 = false;
			IREP.TourToWin.finishTour('week5');
			$(".TTWTourRibbon").remove();
		}
	}
	var changePage = function (sct, page) {
		if (sct == "learning") {
			if (curLearningPage > 0 && curLearningPage < (curWeek +1)) {
				if (page > 0) {
					switch (curLearningPage) {
						case 1:
							$("#Week1Learnings").fadeOut(250, function () { $("#Week2Learnings").delay(200).fadeIn(250); });
							break;
						case 2:
							$("#Week2Learnings").fadeOut(250, function () { $("#Week3Learnings").delay(200).fadeIn(250); });
							break;
						case 3:
							$("#Week3Learnings").fadeOut(250, function () { $("#Week4Learnings").delay(200).fadeIn(250); });
							break;
						case 4:
							$("#Week4Learnings").fadeOut(250, function () { $("#Week5Learnings").delay(200).fadeIn(250); });
							break;
						case 5:
							$("#Week5Learnings").fadeOut(250, function () { $("#Week6Learnings").delay(200).fadeIn(250); });
							break;
						default:
							break;
					}
				} else {
					switch (curLearningPage) {
						case 2:
							$("#Week2Learnings").fadeOut(250, function () { $("#Week1Learnings").delay(200).fadeIn(250); });
							break;
						case 3:
							$("#Week3Learnings").fadeOut(250, function () { $("#Week2Learnings").delay(200).fadeIn(250); });
							break;
						case 4:
							$("#Week4Learnings").fadeOut(250, function () { $("#Week3Learnings").delay(200).fadeIn(250); });
							break;
						case 5:
							$("#Week5Learnings").fadeOut(250, function () { $("#Week4Learnings").delay(200).fadeIn(250); });
							break;
						case 6:
							$("#Week6Learnings").fadeOut(250, function () { $("#Week5Learnings").delay(200).fadeIn(250); });
							break;
						default:
							break;
					}
				}

				if ((curLearningPage + page) > 0 && (curLearningPage + page) < (curWeek + 1)) { 
					curLearningPage = curLearningPage + page;
				}
				
				if (curLearningPage > 1) {
					$("#prevLearning").removeClass("prevNextGray");
					$("#prevLearning").addClass("prevNextBlue");
				} else {
					$("#prevLearning").removeClass("prevNextBlue");
					$("#prevLearning").addClass("prevNextGray");
				}

				if (curLearningPage < curWeek) {
					$("#nextLearning").removeClass("prevNextGray");
					$("#nextLearning").addClass("prevNextBlue");
				} else {
					$("#nextLearning").removeClass("prevNextBlue");
					$("#nextLearning").addClass("prevNextGray");
				}
			}

		} else if (sct == "tour") {
			if (curTourPage > 0 && curTourPage <= (curWeek + 1)) {

				if (page > 0) {
					switch (curTourPage) {
						case 1:
							$("#Week1Tour").fadeOut(250, function () { $("#Week2Tour").delay(200).fadeIn(250); });
							break;
						case 2:
							$("#Week2Tour").fadeOut(250, function () { $("#Week3Tour").delay(200).fadeIn(250); });
							break;
						case 3:
							$("#Week3Tour").fadeOut(250, function () { $("#Week4Tour").delay(200).fadeIn(250); });
							break;
						case 4:
							$("#Week4Tour").fadeOut(250, function () { $("#Week5Tour").delay(200).fadeIn(250); });
							break;
						case 5:
							$("#Week5Tour").fadeOut(250, function () { $("#Week6Tour").delay(200).fadeIn(250); });
							break;
						default:
							break;
					}
				} else {
					switch (curTourPage) {
						case 2:
							$("#Week2Tour").fadeOut(250, function () { $("#Week1Tour").delay(200).fadeIn(250); });
							break;
						case 3:
							$("#Week3Tour").fadeOut(250, function () { $("#Week2Tour").delay(200).fadeIn(250); });
							break;
						case 4:
							$("#Week4Tour").fadeOut(250, function () { $("#Week3Tour").delay(200).fadeIn(250); });
							break;
						case 5:
							$("#Week5Tour").fadeOut(250, function () { $("#Week4Tour").delay(200).fadeIn(250); });
							break;
						case 6:
							$("#Week6Tour").fadeOut(250, function () { $("#Week5Tour").delay(200).fadeIn(250); });
							break;
						default:
							break;
					}
				}

				if ((curTourPage + page) > 0 && (curTourPage + page) < (curWeek + 1)) {
					curTourPage = curTourPage + page;
				}

				if (curTourPage > 1) {
					$("#prevTour").removeClass("prevNextGray");
					$("#prevTour").addClass("prevNextBlue");
				} else {
					$("#prevTour").removeClass("prevNextBlue");
					$("#prevTour").addClass("prevNextGray");
				}

				if (curTourPage < curWeek) {
					$("#nextTour").removeClass("prevNextGray");
					$("#nextTour").addClass("prevNextBlue");
				} else {
					$("#nextTour").removeClass("prevNextBlue");
					$("#nextTour").addClass("prevNextGray");
				}

			}
		}
	}

	return {
		init: init,
		fillData: fillData,
		redeemToken: redeemToken,
		finishTour: finishTour,
		showRibbon: showRibbon,
		startWeek2: startWeek2,
		w2s2: w2s2,
		w2s3: w2s3,
		w2s4: w2s4,
		w3s1: w3s1,
		w3s2: w3s2,
		w3s3: w3s3,
		w3s4: w3s4,
		w4s2: w4s2,
		w4s3: w4s3,
		w5s1: w5s1,
		w5s2: w5s2,
		w5s3: w5s3,
		w5s4: w5s4,
	};
})();

